export { createDeflateEncoder } from './deflateEncoder';
export { startDeflateWorker, getDeflateWorkerStatus, resetDeflateWorkerState, } from './deflateWorker';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@datadog/browser-rum/esm/domain/deflate/index.js